import { CIcon } from '~/icons/types'
export const ciBuffet: CIcon = {
  name: 'buffet',
  type: 'regular',
  width: 512,
  height: 512,
  paths: [
    {
      d:
        'M512 270h-31.504c-3.562-54.453-26.457-105.156-65.398-144.098C382.41 93.215 341.434 71.84 296.91 63.703A44.703 44.703 0 0 0 301 45c0-24.813-20.188-45-45-45s-45 20.188-45 45a44.76 44.76 0 0 0 4.086 18.703c-44.52 8.137-85.496 29.512-118.188 62.2C57.961 164.842 35.063 215.546 31.504 270H0v30h36.73l30 60h138.457l-20 60H151v30h210v-30h-34.188l-20-60H445.27l30-60H512zM241 45c0-8.27 6.73-15 15-15s15 6.73 15 15-6.73 15-15 15-15-6.73-15-15zm15 45c102.477 0 186.742 79.457 194.43 180H61.57C69.258 169.457 153.523 90 256 90zm39.188 330h-78.375l20-60h38.375zm131.542-90H85.27l-15-30h371.46zm0 0',
      fill: 'currentColor'
    }
  ]
}
